import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {map} from 'lodash';

import {getPracticeBasedTitle} from '../utils';
import OneRow from './OneRow';
import STableHeader from './STableHeader';
import STablePage from './STablePage';
import InlineEdit from "common/InlineEdit";

export default function ({selectPage, printable}) {

    const me = useSelector(state => state.me);
    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);
    const [title, setTitle] = useState('');

    const data_table = dashboard_data.data_skill_table;

    const renderRows = () => {
        return map(data_table.items, (one_student, k) => {
            return (
                <OneRow
                    key={k}
                    one_student={one_student}
                    printable={printable}
                />
            );
        });
    }

    function renderTitle() {
        if (me.is_dashboard_super_admin) {
            return (
                <InlineEdit
                    activeClassName="pam-chart-title-input"
                    text={title}
                    paramName="title"
                    change={prop => setTitle(prop.title)}
                    minLength={1}
                    maxLength={500}
                    className='pam-component-table-title'
                    staticElement='div'
                    withIcon={false}
                />
            );
        }

        return (
            <div className='pam-component-table-title'>{title}</div>
        );
    }

    useEffect(() => {
        const new_title = getPracticeBasedTitle(dashboard).s_table;
        if (title !== new_title) {
            setTitle(new_title);
        }
    }, [dashboard]);

    if (!data_table || !me) {
        return null;
    }

    return (
        <div className="pam-component pam-component-table">
            {renderTitle()}

            <div>
                <table className="pam-component-table-main">
                    <STableHeader
                        data_table={data_table}
                        printable={printable}
                    />

                    <tbody>
                        {renderRows()}
                    </tbody>
                </table>
            </div>

            <div>
                <STablePage
                    data_table={data_table}
                    selectPage={selectPage}
                />
            </div>
        </div>
    );
}
